module.exports = __webpack_public_path__ + "assets/images/93e8b7889cde90e90e26bb86580e08e2.png";